import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../RootState';

export interface UserState {
    id: number;
    first_name: string;
    letters: string;
    color: string;
    name: string;
    email: string;
    phone: string;
    telefono_cel: string;
    image: string;
    token: string;
    is_admin: number;
    role_id?: number;
}
export const initialState: UserState = {
    id: 0,
    first_name: '',
    letters: '',
    color: '',
    name: '',
    email: '',
    phone: '',
    telefono_cel: '',
    image: '',
    token: '',
    is_admin: 0,
    role_id: 1,
};
export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser: (state) => {
            state.first_name = 'Luissssss';
        },
    },
});
export const { setUser } = userSlice.actions;
export const selectUser = (state: RootState) => state.User;
export default userSlice.reducer;
